<template>
  <div class="item-base">
      <img :src="'http://'+ContentImg" class="img">
      <div class="right-bg" />

      <div style="padding-top: 40px">
          <span>{{ContentDes}}</span>
      </div>
  </div>
</template>

<script>
  export default {
    name: "ContentBaseItem",
    props:{
      ContentDes:{},
      ContentImg:{},
    }
  }
</script>

<style lang="less" scoped>
  .item-base {
    position: relative;
    .img{
      position: relative;
      width: 510px;
      height: 340px;
      z-index: 6;
      object-fit: cover;
    }
    .right-bg{
      width: 510px;
      height: 340px;
      background: #188ACB;
      opacity: 0.5;
      position: absolute;
      top: 40px;
      left: 25px;
      z-index: 1;
    }
  }
</style>